<template>
  <!-- Contenedor -->
  <div>
    <!-- Introducción al contenido de la pagina -->
    <div class="card-header">
      <h4>INFORME CLÍNICO DE VALORACIÓN</h4>
      <p style="color: darkgray; margin-bottom: 30px">
        Reporte donde se puede ver la valoraciones de un
        <span class="text-success">paciente</span>
      </p>
    </div>

    <!-- Filtros -->
    <div class="card-content">
      <div class="row">
        <div
          class="col-md-4"
          v-if="rol == 1 || rol == 20 || rol == 23 || rol == 19"
        >
          <label for="">Sede:</label>
          <select
            class="form-control"
            v-model="sede"
            @change="cambiarSede()"
            style="background-color: white"
          >
            <option
              v-for="sede in SedesProgramacion"
              :key="sede.sede"
              :value="sede.sede"
            >
              {{ sede.sede }}
            </option>
          </select>
          <br />
        </div>
      </div>
      <div class="row">
        <!-- Selección de paciente -->
        <div class="col-md-4">
          <label for="type_report">Seleccione el Paciente</label>
          <select
            v-model="value"
            id="type_report"
            class="form-control"
            v-if="type_report == 'paciente'"
            style="background-color: white"
          >
            <option
              :value="paciente.id"
              v-for="paciente in listPacientes"
              :key="paciente.id"
            >
              {{ paciente.apellidos }} {{ paciente.nombres }}
            </option>
          </select>
        </div>

        <!-- Botón de búsqueda -->
        <div class="col-md-3" style="margin-top: 25px">
          <button
            class="btn btn-success btn-block btn-fill"
            @click="getEvents()"
            style="border-radius: 5px"
          >
            Buscar
          </button>
        </div>
        <div></div>
      </div>
    </div>
    <br />

    <!-- Tabla -->
    <div class="card">
      <div class="card-content">
        <!-- Selección del paginados -->
        <div class="row" style="padding-left: 15px" v-if="queriedData2 != ''">
          <div class="col-3">
            <el-select
              class="select-default"
              v-model="pagination.perPage"
              placeholder="Per page"
            >
              <el-option
                class="select-default"
                v-for="item in pagination.perPageOptions"
                :key="item"
                :label="item"
                :value="item"
              ></el-option>
            </el-select>
          </div>
        </div>

        <!-- Contenido -->
        <div class="row">
          <br />
          <!-- Contenido por defecto -->
          <div class="col-md-12" v-if="queriedData2 == ''">
            <center>
              <img
                src="/static/img/ICONOS/estadisticas.svg"
                alt="Imagen de datos vacíos"
                width="70"
              />
              <p class="titulo-mensaje">Aún no hay datos para mostrar.</p>
            </center>
          </div>

          <!-- Contenido de la tabla -->
          <div class="col-md-12" ref="component" v-if="queriedData2 != ''">
            <div>
              <!-- <span style="color:darkgray; margin-bottom: 20px;"> {{ queriedData2.length }} registros </span> -->

              <el-table
                class="table-striped"
                :data="queriedData"
                border
                style="width: 100%"
              >
                <el-table-column
                  v-for="column in tableColumns"
                  :key="column.label"
                  :min-width="column.minWidth"
                  :prop="column.prop"
                  :label="column.label"
                >
                  <template #default="{ row }">
                    <span>{{ row[column.prop] }}</span>
                  </template>
                </el-table-column>
                <el-table-column :min-width="40" label="Acción">
                  <template slot-scope="props">
                    <center>
                      <span
                        v-if="props.row.estado == 3"
                        class="badge text-bg-success"
                        style="background-color: red"
                        >Pendiente por evolucionar</span
                      >
                      <span
                        v-if="props.row.estado == 1"
                        class="badge text-bg-success"
                        style="background-color: green"
                        >Evolucionado</span
                      >
                    </center>
                  </template>
                </el-table-column>
                <el-table-column :min-width="40" label="Acción">
                  <template slot-scope="props">
                    <center>
                      <button
                        class="btn btn-fill btn-sm btn-success"
                        title="Exportar a PDF"
                        style="border-radius: 5px"
                        @click="getInfoPDF(props.row)"
                      >
                        <i class="ti-file"></i> Exportar
                      </button>
                    </center>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </div>

        <!-- Pie de pagina del paginado -->
        <div class="row" v-if="queriedData2 != ''">
          <div class="col-sm-6 pagination-info">
            <br />
            <p class="category">
              Showing {{ from + 1 }} to {{ to }} of {{ total }} entries
            </p>
          </div>
          <div class="col-sm-6">
            <p-pagination
              class="pull-right"
              v-model="pagination.currentPage"
              :per-page="pagination.perPage"
              :total="pagination.total"
            ></p-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import axios from "axios";
import { Table, TableColumn, Select, Option } from "element-ui";
import PPagination from "src/components/UIComponents/Pagination.vue";
import crearAlerta from "../../global-services/crearAlerta";
import convertArrayToText from "../../global-services/arrayToText"
import axiosInstance from "src/global-services/axiosInstance";
// add this
import { jsPDF } from "jspdf";
import "jspdf-autotable";

Vue.use(Table);
Vue.use(TableColumn);
Vue.use(Select);
Vue.use(Option);

export default {
  computed: {
    pagedData() {
      return this.queriedData2.slice(this.from, this.to);
    },
    queriedData() {
      if (!this.searchQuery) {
        this.pagination.total = this.queriedData2.length;
        return this.pagedData;
      }
      let result = this.queriedData2.filter((row) => {
        let isIncluded = false;
        for (let key of this.propsToSearch) {
          let rowValue = row[key].toString().toLowerCase();
          if (
            rowValue.includes &&
            rowValue.includes(this.searchQuery.toLowerCase())
          ) {
            isIncluded = true;
          }
        }
        return isIncluded;
      });
      this.pagination.total = result.length;
      return result.slice(this.from, this.to);
    },
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total() {
      this.pagination.total = this.queriedData2.length;
      return this.queriedData2.length;
    },
  },

  data: () => ({
    ip: "https://avanti-erp.com/",
    type_report: "paciente",
    rol: localStorage.getItem("rol"),
    sede: localStorage.getItem("sede"),
    SedesProgramacion: [],
    searchQuery: "",
    value: "",
    logo: "",
    fechaValoracion: "",
    listPacientes: [],
    listTerapeutas: [],
    initialDate: "",
    endDate: "",
    queriedData2: [],
    tableColumns: [
      {
        prop: "fecha", //NOMBRE DEL CAMPO TAL CUAL COMO ESTÁ EN LA BASE DE DATOS
        label: "Fecha", //NOMBRE QUE QUIERES QUE SE REFLEJE EN EL ENCABEZADO DE CADA COLUMNA
        minWidth: 70, //ANCHO DE LA COLUMNA
      },
      {
        prop: "terapeuta",
        label: "Terapeuta",
        minWidth: 100,
      },
      {
        prop: "tipo",
        label: "Tipo",
        minWidth: 50,
      },
    ],
    // add this
    pagination: {
      perPage: 25,
      currentPage: 1,
      perPageOptions: [5, 10, 25, 50, 100, 200, 300],
      total: 0,
    },
    tiposDocumento: {
      NUIP: "NUIP",
      "CÉDULA DE CIUDADANIA": "CC",
      PASAPORTE: "PA",
      "TARJETA DE IDENTIDAD": "TI",
      "CEDULA DE EXTRANJERIA": "CE",
      "REGISTRO CIVIL": "RC",
      NIT: "NI",
      RUT: "RUT",
      "PERMISO POR PROTECCIÓN TEMPORAL": "PPT",
    },
    textoEjemplo:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
  }),

  components: {
    PPagination,
  },

  methods: {
    async getInfoPDF(valoracion) {
      let paciente = [];
      let motivos = [];
      let resumen = [];
      let tratamiento = [];
      let firmas = [];
      let firmasCordinacion = [];
      let antecedentes = [];
      let examenes = [];

      this.fechaValoracion = valoracion.fecha;
      try {
        this.$modal.show("carga");
        const response = await axiosInstance.get(
          `api/reportes/informacion-reporte-evaluacion/${valoracion.idPaciente}/${valoracion.fecha}`
        );
        if (response.data.mensaje == "Faltan examenes para poder exportar") {
          this.$notify(crearAlerta("danger", response.data.mensaje));
          this.$modal.hide("carga");
          return;
        } else {
          paciente = response.data.dataPaciente;
          motivos = response.data.dataMotivo;
          resumen = response.data.dataResumen;
          tratamiento = response.data.dataTratamiento;
          this.logo = response.data.logo;
          firmas = response.data.firmas;
          firmasCordinacion = response.data.firmasCordinacion;
          // Group antecedentes by type
          const antecedentesAgrupados = response.data.antecedentes.reduce((acc, antecedente) => {
            if (!acc[antecedente.tipo]) {
              acc[antecedente.tipo] = [];
            }
            acc[antecedente.tipo].push({ descripcion: antecedente.descripcion });
            return acc;
          }, {});
          
          antecedentes = antecedentesAgrupados;
          examenes = response.data.examenes;
        }
      } catch (error) {
        console.log("Error al obtener los datos:" + error);
      } finally {
        this.generarPDF(
          paciente,
          motivos,
          resumen,
          tratamiento,
          firmas,
          firmasCordinacion,
          antecedentes,
          examenes
        );
        this.$modal.hide("carga");
      }
    },

    generarPDF: function (
      paciente,
      motivo,
      resumen,
      tratamiento,
      firmas,
      firmasCordinacion,
      antecedentes,
      examenes,
    ) {

      if(resumen === null || resumen.length < 1){
        alert('El paciente no tiene valoraciones registradas');
      }
      const doc = new jsPDF();

      let headerHeight = 35;
      const footerHeight = 35;
      const pageHeight = doc.internal.pageSize.height;
      const pageWidth = doc.internal.pageSize.getWidth();
      const anchoTexto = 180;
      const lineHeight = 4;

      let startX = 15;
      let startY = headerHeight + 20;
      let logo = this.logo;

      const addHeader = function (doc) {
        doc.addImage(logo, "png", 0, 0, 210, 40);
      };

      const addFooter = function (doc) {
        const fechaTexto = new Date().toLocaleDateString();
        doc.setFontSize(8);
        doc.setFont("helvetica", "normal");
        doc.setTextColor(100);
        doc.text("Avanti", pageWidth / 2, pageHeight - footerHeight + 7, {
          align: "center",
        });
        doc.text(
          `Fecha impresión: ${fechaTexto}`,
          pageWidth / 2,
          pageHeight - footerHeight + 10,
          { align: "center" }
        );
      };

      const  addSignature =  async (doc, firmas, firmasCordinacion) => {
        const imageWidth = 60;
        const imageHeight = 15;
        const margin = 5;
        let yPosition = startY;
        const todasFirmas = [...firmas, ...firmasCordinacion];

        todasFirmas.forEach((imageData) => {
          console.log(footerHeight, 'footer');
          if( imageData.CamFir1 == null || imageData.CamFir1 == '' ){
            return 'ERROR';
          }

          const xPosition = pageWidth / 2;
          if (yPosition + imageHeight + margin + footerHeight > pageHeight) {
            doc.addPage();
            yPosition = 15;
            addFooter(doc);
            
          }
          // doc.addImage(
          //   imageData,
          //   "PNG",
          //   xPosition,
          //   yPosition,
          //   imageWidth,
          //   imageHeight
          // );
          doc.setFontSize(12);
          doc.setFont("helvetica", "bold");
          doc.setTextColor("#000000");
          doc.text(imageData.nombreTerapeuta.toUpperCase(), xPosition, yPosition + imageHeight + 5, {
            align: "center",
          });
          yPosition += 5 + 0;
          doc.setFontSize(10);
          doc.setFont("helvetica", "normal");
          doc.setTextColor(100);
          doc.text(imageData.CamFir1, xPosition, yPosition + imageHeight + 5, {
            align: "center",
          });
          if(imageData.CamFir2 != null){
            yPosition += 6 + 0;
            doc.setFontSize(10);
            doc.setFont("helvetica", "normal");
            doc.setTextColor(100);
            doc.text(imageData.CamFir2, xPosition, yPosition + imageHeight + 5, {
              align: "center",
            });
          }
          if(imageData.CamFir3 != null){
            yPosition += 6 + 0;
            doc.setFontSize(8);
            doc.setFont("helvetica", "normal");
            doc.setTextColor(100);
            doc.text(imageData.CamFir3, xPosition, yPosition + imageHeight + 5, {
              align: "center",
            });
          }
          yPosition += imageHeight + margin;
        });
      };

      const checkPageSpace = (yPos, extra = 0) => {
        if (yPos + lineHeight + extra >= pageHeight - footerHeight) {
          doc.addPage();
          addFooter(doc);
          startY =  15;
        }
      };

      function renderJustifiedLine(line, x, y, maxWidth) {
        const newLine = line.replace(/\s+/g, " ");
        const words = newLine.split(" ");
        const wordCount = words.length;

        if (wordCount <= 300) {
          doc.text(line, x, y);
          return;
        }

        const totalWordsWidth = words.reduce(
          (total, word) => total + doc.getTextWidth(word),
          0
        );
        const spaceWidth = (maxWidth - totalWordsWidth) / (wordCount - 1);
        let currentX = x;

        words.forEach((word, index) => {
          doc.text(word, currentX, y);
          if (index < wordCount - 1) {
            currentX += doc.getTextWidth(word) + spaceWidth;
          }
        });
      }

      const renderJustifiedText = (text) => {
        const lines = doc.splitTextToSize(text, anchoTexto);
        lines.forEach((line) => {
          checkPageSpace(startY);
          doc.setFontSize(10);
          doc.setFont("helvetica", "normal");
          doc.setTextColor(100);
          renderJustifiedLine(line, startX, startY, anchoTexto);
          startY += lineHeight;
        });
      };

      addHeader(doc);
      addFooter(doc);
      

      doc.setFontSize(14);
      doc.setFont("helvetica", "bold");
      doc.setTextColor("#000000");
      doc.text("DATOS PERSONALES", pageWidth / 2, startY, { align: "center" });
      startY += 5;

      const tableData = [
        [
          {
            content: "NOMBRE DEL PACIENTE",
            styles: { fontSize: 10, fontStyle: "bold", textColor: "#000000" },
          },
          {
            content: `${paciente[0].nombrePaciente} ${paciente[0].apellidoPaciente}`,
            styles: { fontSize: 10 },
            colSpan: 3,
          },
        ],
        [
          {
            content: "FECHA DE NACIMIENTO",
            styles: { fontSize: 10, fontStyle: "bold", textColor: "#000000" },
          },
          {
            content: paciente[0].fechaNacimiento,
            styles: { fontSize: 10 },
          },
          {
            content: "EDAD:",
            styles: { fontSize: 10, fontStyle: "bold", textColor: "#000000" },
          },
          {
            content: this.calcularEdad(paciente[0].fechaNacimiento),
            styles: { fontSize: 10 },
          },
        ],
        [
          {
            content: "TIPO DE IDENTIFICACIÓN",
            styles: { fontSize: 10, fontStyle: "bold", textColor: "#000000" },
          },
          {
            content: this.tiposDocumento[paciente[0].tipoDocumento],
            styles: { fontSize: 10 },
          },
          {
            content: "NUMERO DE DOCUMENTO",
            styles: { fontSize: 10, fontStyle: "bold", textColor: "#000000" },
          },
          {
            content: parseFloat(paciente[0].numeroDocumento).toLocaleString(
              "es-ES"
            ),
            styles: { fontSize: 10 },
          },
        ],
        [
          {
            content: "ESTADO CIVIL",
            styles: { fontSize: 10, fontStyle: "bold", textColor: "#000000" },
          },
          {
            content: 'SOLTERO/A',
            styles: { fontSize: 10 },
            // colSpan: 2,
          },
          {
            content: "SEXO",
            styles: { fontSize: 10, fontStyle: "bold", textColor: "#000000" },
          },
          {
            content: paciente[0].sexo == 1 ? "MASCULINO" : "FEMENINO",
            styles: { fontSize: 10 },
            // colSpan: 2,
          },
        ],
        [
          {
            content: "OCUPACIÓN",
            styles: { fontSize: 10, fontStyle: "bold", textColor: "#000000" },
          },
          {
            content: 'ESTUDIANTE',
            styles: { fontSize: 10 },
            // colSpan: 2,
          },
          {
            content: "DIRECCIÓN",
            styles: { fontSize: 10, fontStyle: "bold", textColor: "#000000" },
          },
          {
            content: paciente[0].direccion != null ? paciente[0].direccion : "SIN DIRECCIÓN",
            styles: { fontSize: 10 },
            // colSpan: 2,
          },
        ],
        [
          {
            content: "TELEFONO",
            styles: { fontSize: 10, fontStyle: "bold", textColor: "#000000" },
          },
          {
            content: paciente[0].telefono != null ? paciente[0].telefono : "SIN TELÉFONO",
            styles: { fontSize: 10 },
            // colSpan: 2,
          },
          {
            content: "LUGAR DE RESIDENCIA",
            styles: { fontSize: 10, fontStyle: "bold", textColor: "#000000" },
          },
          {
            content: paciente[0].ciudad,
            styles: { fontSize: 10 },
            // colSpan: 2,
          },
        ],
        [
          {
            content: "NOMBRE DEL ACUDIENTE",
            styles: { fontSize: 10, fontStyle: "bold", textColor: "#000000" },
          },
          {
            content: paciente[0].acudiente != null ? paciente[0].acudiente : "SIN ACUDIENTE",
            styles: { fontSize: 10 },
            // colSpan: 2,
          },
          {
            content: "TELEFONO DEL ACUDIENTE",
            styles: { fontSize: 10, fontStyle: "bold", textColor: "#000000" },
          },
          {
            content: paciente[0].telefonoAcudiente != null ? paciente[0].telefonoAcudiente : "SIN TELÉFONO",
            styles: { fontSize: 10 },
            // colSpan: 2,
          },
        ],
        [
          {
            content: "ENTIDAD ASEGURADORA",
            styles: { fontSize: 10, fontStyle: "bold", textColor: "#000000" },
          },
          {
            content: paciente[0].entidad,
            styles: { fontSize: 10 },
          },
          {
            content: "TIPO DE AFILIACIÓN",
            styles: { fontSize: 10, fontStyle: "bold", textColor: "#000000" },
          },
          {
            content: paciente[0].regimen == 1 ? "CONTRIBUTIVO" : "SUBSIDIADO",
            styles: { fontSize: 10 }
          },
          
        ],
        [
          {
            content: "DIAGNÓSTICO (S) MÉDICO (S):",
            styles: { fontSize: 10, fontStyle: "bold", textColor: "#000000" },
          },
          {
            content: paciente[0].diagnostico != null ? paciente[0].diagnostico : "Sin diagnóstico",
            styles: { fontSize: 10 },
            colSpan: 3,
          },
        ],
        [
          {
            content: "FECHA DE VALORACIÓN:",
            styles: { fontSize: 10, fontStyle: "bold", textColor: "#000000" },
          },
          {
            content: this.fechaValoracion,
            styles: { fontSize: 10 },
            colSpan: 3,
          },
        ],
      ];

      doc.autoTable({
        startY: startY,
        theme: "grid",
        body: tableData,
        margin: { top: headerHeight + 15, bottom: footerHeight + 20 },
        styles: {
          fontSize: 10,
          cellPadding: { top: 2, bottom: 2, left: 2, right: 2 },
        },
        pageBreak: "auto",
      });

      //Antecedentes del paciente
      startY = doc.lastAutoTable.finalY + 10;
      checkPageSpace(startY);
      doc.setFontSize(14);
      doc.setFont("helvetica", "bold");
      doc.setTextColor("#000000");
      doc.text("ANTECEDENTES", pageWidth / 2, startY, { align: "center" });
      startY += 8;

      const tiposAntecedentes = {
        1: 'Prenatales',
        2: 'Neonatales',
        3: 'Posnatales',
        4: 'Personales',
        5: 'Familiares'
      }

      let antecedentesTablaData = [];
      Object.keys(antecedentes).forEach( tipo => {
        antecedentesTablaData.push([
          {
            content: tiposAntecedentes[tipo],
            styles: { fontSize: 10, fontStyle: "bold", textColor: "#000000" },
          },
          {
            content: antecedentes[tipo].length > 0 ? convertArrayToText(antecedentes[tipo], "descripcion") : "",
            styles: { fontSize: 10 },
          },
        ])
      })

      doc.autoTable({
        startY: startY,
        theme: "grid",
        body: antecedentesTablaData,
        margin: { top: 15, bottom: footerHeight + 25 },
        styles: {
          // minCellHeight: 7 * 1.15,
          fontSize: 8,
          cellPadding: { top: 2, bottom: 2, left: 2, right: 2 },
        },
        
      });

      startY = doc.lastAutoTable.finalY + 10;
      // examenes realizados al paciente
      checkPageSpace(startY);
      doc.setFontSize(14);
      doc.setFont("helvetica", "bold");
      doc.setTextColor("#000000");
      doc.text("EXAMENES REALIZADOS", pageWidth / 2, startY, { align: "center" });
      startY += 8;

      const labelExamen = [
        '',
        'Formato de evaluación de terapia ocupacional (AVANZA)',
        'Formato de evaluación psicología niños',
        'Formato de evaluación fonoaudiólogia función oral faringea',
        'Formato de evaluación fonoaudiólogia lenguaje',
        'Examen fisico basado en neurodesarrollo (AVANZA)',
        'Evaluación de la desorganización postural',
        'Formato de evaluación musculoesquelética',
        'Psicología adulto',
        'Evaluación cognitiva',
        'Evaluación comportamental',
        'Revisión por sistemas',
        'Actualización historia clínica',
        'Desempeño ocupacional',
        'EAT. 10',
        'Formato miofuncional',
        'Formato conductual niños',
        'Formato psicoterapia adultos',
        'Formato RH niños',
        'Formato rehabilitación cog. adultos',
        'Formato test articular',
        'Formato test lectoescritura'
      ]

      let examenesTabla = [];
      examenes.forEach( item => {
        examenesTabla.push([
          {
            content: labelExamen[item.tipo],
            styles: { fontSize: 10, fontStyle: "bold", textColor: "#000000" },
          },
        ])
      })

      if(examenesTabla.length > 0) {
        doc.autoTable({
          startY: startY,
          theme: "grid",
          body: examenesTabla,
          margin: { top: 15, bottom: footerHeight + 20 },
          styles: {
            // minCellHeight: 7 * 1.15,
            fontSize: 8,
            cellPadding: { top: 2, bottom: 2, left: 2, right: 2 },
          },
          pageBreak: "auto",
        });
      }else{
        doc.setFontSize(10);
        doc.setFont("helvetica", "normal");
        doc.setTextColor("#000000");
        doc.text("No se han realizado examenes", pageWidth / 2, startY, { align: "center" });
      }


      // motivo de consulta
      if(examenesTabla.length > 0){
        startY = doc.lastAutoTable.finalY + 30;
      }else{
        startY += 20;
        // checkPageSpace(startY+15);
      }
      checkPageSpace(startY+15);
      doc.setFontSize(14);
      doc.setFont("helvetica", "bold");
      doc.setTextColor("#000000");
      doc.text("MOTIVO CONSULTA", pageWidth / 2, startY, { align: "center" });
      startY += 15;

      motivo.forEach((mov) => {
        doc.setFontSize(10);
        doc.setFont("helvetica", "normal");
        doc.setTextColor(100);
        renderJustifiedText(mov.MotDes);
        startY += lineHeight;
        renderJustifiedText(mov.MotVer);
        startY += lineHeight;
      });
      startY += 15;
      checkPageSpace(startY);
      doc.setFontSize(14);
      doc.setFont("helvetica", "bold");
      doc.setTextColor("#000000");
      doc.text("VALORACIÓN CLÍNICA", pageWidth / 2, startY, {
        align: "center",
      });
      startY += 10;

      resumen.forEach((res) => {
        doc.setFontSize(10);
        doc.setFont("helvetica", "normal");
        doc.setTextColor(100);
        renderJustifiedText(res.ResDes);
        startY += 4;
        doc.text(res.terapeuta, startX, startY);
        startY += 3;
        doc.line(15, startY, 193, startY);
        startY += 10;
      });
      startY += 30;
      checkPageSpace(startY);
      doc.setFontSize(14);
      doc.setFont("helvetica", "bold");
      doc.setTextColor("#000000");
      doc.text("PLAN DE TRATAMIENTO", pageWidth / 2, startY, {
        align: "center",
      });
      startY += 8;

      checkPageSpace(startY);
      doc.setFontSize(10);
      doc.setFont("helvetica", "bold");
      doc.setTextColor("#000000");
      doc.text("CONCLUSIONES:", 14, startY);
      startY += 10;

      tratamiento.forEach((item) => {
        doc.setFontSize(10);
        doc.setFont("helvetica", "normal");
        doc.setTextColor(100);
        renderJustifiedText(item.TraDes);
        startY += 5;
      });
      startY += 10;

      checkPageSpace(startY);
      doc.setFontSize(10);
      doc.setFont("helvetica", "bold");
      doc.setTextColor("#000000");
      doc.text("RECOMENDACIONES:", 14, startY);
      startY += 10;

      tratamiento.forEach((item) => {
        doc.setFontSize(10);
        doc.setFont("helvetica", "normal");
        doc.setTextColor(100);
        renderJustifiedText(item.TraActFam);
        startY += 5;
      });
      startY += 10;

      const pageCount = doc.internal.getNumberOfPages();
      for (let i = 1; i <= pageCount; i++) {
        doc.setPage(i);
        const pageLabel = `Pag ${i} de ${pageCount}`;
        const textWidth = doc.getTextWidth(pageLabel);
        doc.setFontSize(8);
        doc.setFont("helvetica", "normal");
        doc.setTextColor(100);
        doc.text(
          pageLabel,
          (pageWidth - textWidth) / 2,
          pageHeight - footerHeight + 13
        );
      }
      const addSignatureValidation =  addSignature(doc, firmas, firmasCordinacion);
      if(addSignatureValidation === 'ERROR'){
        this.$notify(crearAlerta("danger", "El terapeuta no tiene firma registrada"));
        this.$modal.hide("carga"); 
        return;
      }

      const nombreArchivo =
        `valoracion_${paciente[0].nombrePaciente}_${paciente[0].apellidoPaciente}`
          .toLowerCase()
          .replace(/\s+/g, "_")
          .replace(/[^\w_]/g, "");

      doc.save(`${nombreArchivo}.pdf`);
    },

    getEvents: function () {
      if (this.value == "") {
        this.$notify(
          crearAlerta("danger", "Parámetros incompletos para la búsqueda")
        );
        return;
      }

      this.$modal.show("carga");
      const config = {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      };
      const BASE_URL = `${this.ip}api/reportes/evaluaciones/${this.value}`;
      axios
        .get(BASE_URL, config)
        .then((res) => {
          const datos = res.data.data.map((element) => ({
            fecha: element.fecha,
            terapeuta: element.nombreTerapeuta,
            auxiliar: `N/A`,
            idPaciente: element.idPaciente,
            tipo: element.tipo == "Evaluacion" ? "Evaluación" : "Reevaluación",
            estado: element.estado,
          }));
          this.queriedData2 = datos;
          this.$modal.hide("carga");
        })
        .catch((err) => {
          this.$modal.hide("carga");
          console.log(err);
        });
    },

    calcularEdad(fecha) {
      var fechaNacimiento = fecha;
      var values = fechaNacimiento.split("-");
      var dia = values[2];
      var mes = values[1];
      var ano = values[0];

      var fecha_hoy = new Date();
      var ahora_ano = fecha_hoy.getFullYear();
      var ahora_mes = fecha_hoy.getMonth() + 1;
      var ahora_dia = fecha_hoy.getDate();

      var fechaActual = ahora_ano + "-" + ahora_mes + "-" + ahora_dia;
      // this.fechaIngreso = fechaActual;

      var edad = ahora_ano + 0 - ano;
      if (ahora_mes < mes) {
        edad--;
      }
      if (mes == ahora_mes && ahora_dia < dia) {
        edad--;
      }
      if (edad > 1900) {
        edad -= 1900;
      }

      // calculamos los meses
      var meses = 0;
      if (ahora_mes > mes) meses = ahora_mes - mes;
      if (ahora_mes < mes) meses = 12 - (mes - ahora_mes);
      if (ahora_mes == mes && dia > ahora_dia) meses = 11;

      // calculamos los dias
      var dias = 0;
      if (ahora_dia > dia) dias = ahora_dia - dia;
      if (ahora_dia < dia) {
        var ultimoDiaMes = new Date(ahora_ano, ahora_mes - 1, 0);
        var dias = ultimoDiaMes.getDate() - (dia - ahora_dia);
      }

      // this.anos = edad;
      // this.meses = meses;
      return `${edad} año(s) y ${meses} mes(es)`;
    },

    getListPacientes: function () {
      this.$modal.show("carga");
      const config = {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      };
      const sede = this.sede;
      const BASE_URL = `${this.ip}api/list-pacientes/${sede}`;
      axios
        .get(BASE_URL, config)
        .then((res) => {
          this.$modal.hide("carga");
          this.listPacientes = res.data.data;
        })
        .catch((err) => {
          this.$modal.hide("carga");
          alert(
            "Ocurrió un error al traer los eventos, por favor comunique al administrador. ERROR: " +
              err
          );
          console.log(err);
        });
    },

    selectTerapeutas: function (especialidad) {
      this.$modal.show("carga");
      const config = {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      };
      const BASE_URL = `${this.ip}api/selectTerapeutasProgramar/${especialidad}`;
      axios
        .get(BASE_URL, config)
        .then((res) => {
          this.$modal.hide("carga");
          this.listTerapeutas = res.data.data;
        })
        .catch((err) => {
          this.$modal.hide("carga");
          console.log(err);
        });
    },
    cambiarSede: function () {
      this.getListPacientes();
    },
    emailsProgramacion: function () {
      let config = {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      };
      const BASE_URL = `${this.ip}api/emailsProgramacion`;
      axios
        .get(BASE_URL, config)
        .then((res) => {
          let data = res.data.data;
          this.SedesProgramacion = data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },

  mounted() {
    this.getListPacientes();
    this.selectTerapeutas(1);
    this.emailsProgramacion();
  },
};
</script>

<style>
.grid-container {
  display: grid;
  grid-template-columns: 3fr 1fr 1fr 1fr;
  grid-template-rows: repeat(4, auto);
  gap: 2px;
}

.grid-item {
  border: 1px solid #ccc;
  display: flex;
  align-items: center;
  justify-content: center;
}

.cabecera {
  font-size: 20px;
  font-weight: bold;
  color: darkgray;
}
</style>



// WEBPACK FOOTER //
// src/components/Reportes/valoraciones.vue